import "core-js/modules/web.timers.js";
export default {
  __name: 'DropdownTint',
  setup: function setup(__props) {
    var _useNuxtApp = useNuxtApp(),
      $cropContent = _useNuxtApp.$cropContent;
    var modalityStore = useModalityStore();
    var bodyClassName = 'dropdown-open';
    var shown = computed(function () {
      return modalityStore.dropdowns.length > 0;
    });
    var isXSScreen = ref(false);
    var mediaQuery = window.matchMedia('(min-width: 576px)');
    isXSScreen.value = !mediaQuery.matches;
    mediaQuery.onchange = function (e) {
      isXSScreen.value = !e.matches;
    };
    var el = null;
    onMounted(function () {
      el = document.getElementById('__layout');
    });
    var showTint = computed(function () {
      return shown.value && isXSScreen.value;
    });
    watch(showTint, function (newVal) {
      if (newVal) {
        $cropContent();
        requestAnimationFrame(function () {
          el.classList.add('push-content');

          // Wait for class push-content apply
          requestAnimationFrame(function () {
            if (shown.value) {
              el.classList.add(bodyClassName);
            }
          });
        });
      } else {
        el.classList.remove(bodyClassName);
        if (!modalityStore.tintShown && process.client) {
          setTimeout(function () {
            if (!shown.value) el.classList.remove('push-content');
          }, isXSScreen.value ? 350 : 0);
        }
      }
    });
    function closeAll(e) {
      e.stopPropagation();
      modalityStore.closeDropdowns();
    }
    return {
      __sfc: true,
      $cropContent: $cropContent,
      modalityStore: modalityStore,
      bodyClassName: bodyClassName,
      shown: shown,
      isXSScreen: isXSScreen,
      mediaQuery: mediaQuery,
      el: el,
      showTint: showTint,
      closeAll: closeAll
    };
  }
};